// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cursor-pointer[data-v-ebc29534]{cursor:pointer}.word-break[data-v-ebc29534]{word-break:break-word}", ""]);
// Exports
module.exports = exports;
